// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// Validations library http://vee-validate.logaretm.com/
import VeeValidate from 'vee-validate'
import Vue from 'vue'
import vueConfig from 'vue-config'
// Filter
import vueFilter from 'vue-filter'
// import '../static/assets/css/fontello.css';
// import '../static/assets/css/fontello-embedded.css';
// import '../static/assets/css/fontello-codes.css';
// import '../static/assets/css/elcom-styles.css';
// Vue resource library https://github.com/pagekit/vue-resource/blob/develop/docs/http.md
import resource from 'vue-resource'
// https://github.com/kaorun343/vue-youtube-embed
import VueYouTubeEmbed from 'vue-youtube-embed'
import contactUs from './components/contactUs.vue'
import donateRgForm from './components/donateRgForm.vue'
import loyaltyForm from './components/loyaltyForm.vue'
// Components
import newsletterSignup from './components/newsletterSignup.vue'
//import wwfSlickSlider from './components/wwfSlickSlider.vue'
import partnershipsForm from './components/partnershipsForm.vue'
import myPetitionForm from './components/petitionForm.vue'
import myTwitchForm from './components/twitchForm'
import wwfMenuCountryListBtn from './components/wwfMenuCountryListBtn.vue'
import wwfRichmondFcForm from './components/wwfRichmondFcForm.vue'
import youtubeVideo from './components/youtubeVideo.vue'
// Store - Vuex
import store from './store/index'

Vue.use(resource)

Vue.use(VueYouTubeEmbed)

Vue.use(VeeValidate, { events: 'change' });

Vue.use(vueConfig, wwfconfigs)

// Vue Cookie
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);


Vue.use(vueFilter)


Vue.config.productionTip = false

new Vue({
  el: '#bodyapp',
  store,
  data: {
    thankYouPopup: {
      title: '',
      message: '',
      shareButton: false,
      recommendedReading: false,
      component: '',
      componentparams: ''
    }
  },
  mounted() {
    var url = window.location.pathname;
    var filename = url.substring(url.lastIndexOf('/') + 1);

    // Don't mount the reveal if edit mode
    if (!(filename == "edit.aspx" || filename == "Edit.aspx")) {
      this.reveal = new Foundation.Reveal($('#reveal-dialog'), {
        // These options can be declarative using the data attributes
        animationIn: 'fade-in-up fast',
      });
    }
  },
  methods: {
    openThankYouPopup: function (e) {
      [this.thankYouPopup.title, this.thankYouPopup.message, this.thankYouPopup.shareButton, this.thankYouPopup.recommendedReading, this.thankYouPopup.component, this.thankYouPopup.componentparams] = e;
      this.reveal.open();
    }
  },
  components: { donateRgForm, youtubeVideo, newsletterSignup, myPetitionForm, myTwitchForm, contactUs, loyaltyForm, wwfRichmondFcForm, wwfMenuCountryListBtn, partnershipsForm }
});


// WEBPACK FOOTER //
// ./src/wwf.main.js